import { Button } from "@mui/material";
import { useMemo } from "react";

import { AreaItem } from "../Header/HeaderUtils";
import { useNursingFunctionsContext } from "./NursingFunctionsProvider";

export function PillList() {
	const { areas, selectedAreaId, setSelectedAreaId } = useNursingFunctionsContext();

	const renderedItemPills = areas.map((area: AreaItem) => {
		const isPillSelected = selectedAreaId === area.id;
		return (
			<Button
				key={area.id}
				className={`functions__options__content__pill ${
					isPillSelected && "functions__options__content__pill--active"
				}`}
				disableRipple
				onClick={() => setSelectedAreaId(isPillSelected ? "" : area.id)}
			>
				{area.name}
			</Button>
		);
	});

	return <>{renderedItemPills}</>;
}
